export enum AppEnv {
  DEV = 'dev',
  PROD = 'prod',
  QA = 'qa',
  UAT = 'uat',
}

export type AppConfig = {
  env: AppEnv;
  version: string;
  apiBaseUrl: string;
  mapKey: string;
  instrumentationKey: string;
  instrumentationEnv: string;
  instrumentationAppId: string;
  instrumentationClientToken: string;
  featureFlagProviderKey: string;
  heapEnvId: string;
  auth: {
    authority: string;
    cdiAuthority: string;
    cdiCreateAccountUrl: string;
    knownAuthority: string;
    clientId: string;
    gmFleetClientId: string;
    // staticLoginRedirectUri only needed for dev1 for personal branch deployment
    staticLoginRedirectUri?: string;
    cdiLogoutBaseUrl: string;
    maxAge: string;
    cdiProfileUrl: string;
    insights: {
      oviAuthority: string;
      clientId: string;
      oviPostLogoutRedirectUri: string;
    };
  };
  servicePortalUrl: string;
  mfs: {
    businessEnrollmentEntryUrl: string;
    csBackofficeEntryUrl: string;
    insightsEntryUrl: string;
  };
  inactivityTimer: number;
  legalTermsBaseUrl: string;
  cdnBaseUrl: string;
  zuoraPublishableKey: string;
  /** Zuora hosted payment form profile ID (ACH + credit card). */
  zuoraFormId: string;
  /** Zuora payment form profile ID for the Quickpay flow. */
  zuoraQuickpayFormId: string;
  /** Enables the Quick Pay public flow. Remove after product launch */
  quickPayEnabled?: boolean;
  /**
   * Development-only switches for reports-scheduler-api. Remove once the
   * schedule API is available in every environment.
   */
  reportsScheduler?: {
    /** Serve schedule requests from the in-app mock instead of the API. */
    useMock?: boolean;
    /** Make the mock reject requests, to exercise failure handling. */
    mockFailure?: boolean;
  };
};
